// @generated da scripts/i18n-sr-cyrl.mjs — NON EDITARE A MANO.
// i18n area 'auth' — locale sr-Cyrl-RS: TRASLITTERAZIONE MECCANICA
// di auth.sr-Latn-RS.ts (srpska latinica). Ogni modifica va fatta
// sulla locale sr-Latn-RS e poi rigenerata con: node scripts/i18n-sr-cyrl.mjs
// Sidecar anti-stantie: ../meta/auth.sr-Cyrl-RS.meta.json.
import type { enUS } from './auth'

export const srCyrlRS: typeof enUS = {
  login: {
    welcome: 'Trantor TVirt v6',
    subtitle: 'Пријавите се на свој налог',
    username: 'Корисничко име',
    usernamePlaceholder: 'Унесите корисничко име',
    usernameHint: 'Користите korisnik@domen за аутентификацију на реалму директоријума',
    continue: 'Настави',
    changeUser: 'Нисте ви?',
    password: 'Лозинка',
    forgotPassword: 'Заборавили сте лозинку?',
    submit: 'Пријави се',
    otp: 'Једнократни код',
    otpSubtitle: 'Унесите код из свог аутентификатора',
    otpHint: 'Шест цифара из апликације за аутентификацију, или један од кодова за опоравак',
    otpSubmit: 'Провери',
    invalidCredentials: 'Неисправно корисничко име или лозинка',
    tooManyAttempts: 'Превише покушаја — сачекајте тренутак и покушајте поново',
    realmUnavailable: 'Реалм тренутно не може да провери акредитиве — store кластера није доступан. Пријавите се као локални корисник (break-glass).',
    genericError: 'Пријава није успела — да ли је TVirt backend доступан?'
  },
  user: {
    logout: 'Одјави се',
    password: {
      menu: 'Промени лозинку',
      title: 'Промените своју лозинку',
      current: 'Тренутна лозинка',
      new: 'Нова лозинка',
      confirm: 'Потврдите нову лозинку',
      mismatch: 'Лозинке се не поклапају',
      error: 'Лозинку није могуће променити',
      forcedTitle: 'Промените лозинку да бисте наставили',
      forcedHint: 'Ову лозинку је поставио администратор и мора се заменити пре уласка.',
      forcedSubmit: 'Промени и уђи'
    },
    mfa: {
      title: 'Двофакторска аутентификација',
      subtitle: 'Други фактор који се тражи при свакој пријави',
      loadError: 'Стање другог фактора није могуће учитати',
      enrolled: 'Активан',
      notEnrolled: 'Није активан',
      enrolledAt: 'Активирано',
      codesRemaining: 'Преостали кодови за опоравак',
      requiredHint: 'Администратор захтева други фактор на овом налогу: конфигуришите га сада — док то не урадите можете да се пријавите, али мало шта друго.',
      enroll: 'Конфигуриши',
      enrollTitle: 'Конфигуришите двофакторску аутентификацију',
      enrollHint: 'Скенирајте овај код апликацијом за аутентификацију, затим укуцајте код који она приказује да бисте потврдили.',
      secretHint: 'Не можете да га скенирате? Укуцајте ову тајну у апликацију:',
      code: 'Код из апликације',
      confirm: 'Потврди',
      startError: 'Конфигурацију није могуће покренути',
      confirmError: 'Конфигурацију није могуће потврдити',
      codesTitle: 'Ваши кодови за опоравак',
      codesWarning: 'Ови кодови се приказују само једном. Сачувајте их сада: сваки вас пријављује када аутентификатор није доступан, и важи само једном.',
      codesAck: 'Кодови за опоравак су сачувани',
      codesDone: 'Готово',
      copy: 'Копирај',
      copied: 'Копирано',
      download: 'Преузми',
      regenerate: 'Нови кодови за опоравак',
      regenerateTitle: 'Регенеришите кодове за опоравак',
      regenerateHint: 'Сви до сада издати кодови престају да раде у тренутку када се генерише нови set.',
      regenerateConfirm: 'Регенериши',
      regenerateError: 'Кодове за опоравак није могуће регенерисати',
      remove: 'Уклони',
      removeTitle: 'Уклоните други фактор',
      removeConfirm: 'Уклони',
      removeHint: 'Налог се враћа само на лозинку. Други фактор можете поново конфигурисати кад год желите.',
      removeRequiredHint: 'Администратор захтева други фактор на овом налогу, па ће сервер одбити уклањање — замолите га прво да укине обавезу.',
      removeError: 'Други фактор није могуће уклонити'
    },
    profile: {
      menu: 'Иди на мој профил',
      sessions: 'Активне сесије',
      sessionsHint: 'Ваше отворене сесије на овом чвору',
      sessionsEmpty: 'Нема активних сесија',
      sessionCreated: 'Пријава',
      sessionExpires: 'Истиче',
      revoke: 'Опозови сесију',
      revokeError: 'Сесију није могуће опозвати',
      loadError: 'Сесије није могуће учитати'
    }
  }
}
